import { useState } from "react";
import emailjs from "@emailjs/browser";
import { Helmet } from "react-helmet";
import "./contact.scss";

export default function Contact() {
  const [formData, setFormData] = useState({
    prenom: "",
    nom: "",
    email: "",
    message: "",
    valid: false,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.valid) {
      alert("Veuillez accepter la politique de confidentialité.");
      return;
    }

    const templateParams = {
      prenom: formData.prenom,
      nom: formData.nom,
      email: formData.email,
      message: formData.message,
    };

    setLoading(true);

    try {
      const SERVICE_ID = "service_qn4wi23";
      const TEMPLATE_ID = "template_t3t1sbs";
      const PUBLIC_KEY = "1eXX9OLyZG2KPSixm";

      const response = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      );

      alert("Merci ! Votre message a été envoyé.");
      setFormData({
        prenom: "",
        nom: "",
        email: "",
        message: "",
        valid: false,
      });
    } catch (error) {
      console.error("Erreur EmailJS :", error);
      alert("Une erreur est survenue. Veuillez vérifier vos identifiants EmailJS et réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact">
      {/* Helmet SEO et Open Graph */}
      <Helmet>
        <title>Contact - Er-Raysy Web & Education</title>
        <meta name="description" content="Contactez Er-Raysy Web & Education pour toute demande de devis ou informations sur les services web et soutien scolaire." />
        <meta name="keywords" content="contact, devis, site web, soutien scolaire, Er-Raysy, services web, éducation" />
        <meta name="author" content="Er-Raysy Web & Education" />

        {/* Open Graph pour réseaux sociaux */}
        <meta property="og:title" content="Contact - Er-Raysy Web & Education" />
        <meta property="og:description" content="Contactez-nous pour obtenir un devis ou plus d'informations sur nos services web et pédagogiques." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content="URL_DE_TON_LOGO_OU_IMAGE" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact - Er-Raysy Web & Education" />
        <meta name="twitter:description" content="Contactez-nous pour obtenir un devis ou plus d'informations sur nos services web et pédagogiques." />
        <meta name="twitter:image" content="URL_DE_TON_LOGO_OU_IMAGE" />
      </Helmet>

      <div className="contact__container">
        <h1>Contact</h1>
        <p className="contact__intro">
          Pour toute demande d'information ou de devis, merci de compléter le formulaire ci-dessous.
        </p>

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="form_group">
            <label htmlFor="prenom">Prénom *</label>
            <input type="text" id="prenom" required value={formData.prenom} onChange={handleChange} />
          </div>

          <div className="form_group">
            <label htmlFor="nom">Nom *</label>
            <input type="text" id="nom" required value={formData.nom} onChange={handleChange} />
          </div>

          <div className="form_group">
            <label htmlFor="email">Adresse e-mail *</label>
            <input type="email" id="email" required value={formData.email} onChange={handleChange} />
          </div>

          <div className="form_group">
            <label htmlFor="message">Message *</label>
            <textarea id="message" rows="6" required value={formData.message} onChange={handleChange} />
          </div>

          <div className="contact__checkbox">
            <input type="checkbox" id="valid" checked={formData.valid} onChange={handleChange} required />
            <label htmlFor="valid">
              J’accepte que mes données soient traitées conformément à la politique de confidentialité.
            </label>
          </div>

          <button type="submit" className="contact__button" disabled={loading}>
            {loading ? "Envoi en cours..." : "Envoyer la demande"}
          </button>
        </form>
      </div>
    </div>
  );
}